/**
 * 
 * @param {Object} state 
 * @param {Number, String} item 
 * @returns 
 */
const SET_ADD_ITEM_IN_COMPARATOR = (state, item) => {
  return state.itemsInComparator.push(item)
}

/**
 * 
 * @param {Object} state 
 * @param {Number, String} item 
 * @returns 
 */
 const SET_REMOVE_ITEM_FROM_COMPARATOR = (state, item) => {
  return state.itemsInComparator.includes(item) ? state.itemsInComparator.splice(state.itemsInComparator.indexOf(item), 1) : state.itemsInComparator
}

export default {
  SET_ADD_ITEM_IN_COMPARATOR,
  SET_REMOVE_ITEM_FROM_COMPARATOR,
};
